import axios from '../../core/services/axios';

// eslint-disable-next-line import/prefer-default-export
export const getProfile = (params) => axios.get('/api/profile', { params });
export const connectInitiativeById = (userid) => axios.post('/api/link-account', { user_id: userid });
